import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id D243B11E-D824-4185-B14F-B1C53DB11C24
 * name image-broken-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-broken-variant.svg
 * tags
 */
export const ImageBrokenVariantIcon = createSvgIcon(<><path d="M21,5V11.59L18,8.58L14,12.59L10,8.59L6,12.59L3,9.58V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5M18,11.42L21,14.43V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V12.42L6,15.41L10,11.41L14,15.41" /></>, 'ImageBrokenVariantIcon');
export default ImageBrokenVariantIcon